import GET_BUYING_GROUP_SALES_DOC_TYPE from './getBuyingGroupSalesDocumentType.graphql'
import SET_BUYING_GROUP_SALES_DOC_TYPE from './setBuyingGroupSalesDocumentType.graphql'

export * from './hooks'
export { GET_BUYING_GROUP_SALES_DOC_TYPE, SET_BUYING_GROUP_SALES_DOC_TYPE }
